import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useInsertSystemBranch = isCreateCodding => {
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line default-param-last
  const insertSystemBranch = (isUpdate, data = {}, onSuccess) => {
    if (loading) {
      enqueueSnackbar('عملیات در حال انجام است.', {
        variant: 'info',
      });
      return;
    }
    let url;
    let method = 'post';
    if (!!isCreateCodding) {
      url = `Product/Branch/Codding/System/Insert`;
    } else if (!!isUpdate) {
      url = `Product/Branch/Codding/System/Update`;
      method = 'put';
    } else {
      url = `Product/Branch/Insert`;
    }
    setLoading(true);
    axiosClient({
      url,
      data: { ...data },
      method,
    })
      .then(res => {
        if (res.status === 200 && res.data.result) {
          if (onSuccess) onSuccess(res.data.result);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar('خطایی در برقراری ارتباط رخ داد.', {
          variant: 'error',
        });
      })
      .finally(() => setLoading(false));
  };
  return {
    insertSystemBranch,
    insertSystemBranchLoading: loading,
  };
};

export default useInsertSystemBranch;
